import s from "./recordsMatch.js";
const f = (r, a) => !r || !a || !(r instanceof Array) ? !1 : r.some((e) => s(e, a));
export {
  f as default
};
